import React from 'react';
import { motion } from 'framer-motion';
import menissez from '../../assets/menissez.webp';

// Mock data for partners - in a real app, this could come from an API or config
const partners = [
  { name: 'Menissez', logo: menissez, type: 'Majeur' },
  { name: 'Menissez', logo: menissez, type: 'Majeur' },
  { name: 'Menissez', logo: menissez, type: 'Officiel' },
  { name: 'Menissez', logo: menissez, type: 'Officiel' },
  { name: 'Menissez', logo: menissez, type: 'Institutionnel' },
  { name: 'Menissez', logo: menissez, type: 'Majeur' },
  { name: 'Menissez', logo: menissez, type: 'Officiel' },
  { name: 'Menissez', logo: menissez, type: 'Institutionnel' },
];

export default function PartenairesSection() {
  return (
    <section className="w-full py-16 bg-efafcDark relative overflow-hidden">

      <div className="container mx-auto px-4 mb-10 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-title font-bold text-white mb-2 uppercase tracking-wider">
            Nos <span className="text-efafcYellow">Partenaires</span>
          </h2>
          <div className="w-24 h-1 bg-efafcGreen mx-auto rounded-full mb-6" />
          <p className="text-gray-300 max-w-2xl mx-auto font-body">
            Ils soutiennent le club et participent à notre réussite. Merci à eux pour leur confiance et leur engagement à nos côtés.
          </p>
        </motion.div>
      </div>

      {/* Marquee Container */}
      <div className="relative w-full overflow-hidden py-8 bg-white/5 backdrop-blur-sm border-y border-white/10">
        <div className="flex w-[200%]">
          {/* First Loop */}
          <motion.div
            className="flex items-center gap-12 px-6 min-w-full justify-around"
            animate={{ x: ["0%", "-100%"] }}
            transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          >
            {partners.map((partner, index) => (
              <div
                key={`p1-${index}`}
                className="flex-shrink-0 group relative"
              >
                <div className="absolute inset-0 bg-efafcYellow/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-16 md:h-20 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300 transform group-hover:scale-110 relative z-10"
                />
              </div>
            ))}
          </motion.div>

          {/* Second Loop (Duplicate for seamless scroll) */}
          <motion.div
            className="flex items-center gap-12 px-6 min-w-full justify-around"
            animate={{ x: ["0%", "-100%"] }}
            transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
          >
            {partners.map((partner, index) => (
              <div
                key={`p2-${index}`}
                className="flex-shrink-0 group relative"
              >
                <div className="absolute inset-0 bg-efafcYellow/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-16 md:h-20 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300 transform group-hover:scale-110 relative z-10"
                />
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      <div className="text-center mt-10">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-8 py-3 rounded-xl border border-white/20 text-white font-accent hover:bg-white/10 transition-colors"
        >
          Devenir partenaire
        </motion.button>
      </div>
    </section>
  );
}